const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量动漫资源',
    desc: '收录超过5000部日漫、国漫、韩漫作品，涵盖热血、恋爱、奇幻、悬疑等全品类，持续更新扩充中。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '同步追更速度',
    desc: '与日本、国内各大平台同步更新，新番上线后最快2小时内即可在线阅读，追更不落后。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读体验',
    desc: '专为移动端优化的下拉式阅读模式，无需翻页等待，流畅的纵向滚动带来沉浸式追漫体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费无需注册',
    desc: '所有动漫内容完全免费开放，无需注册账号即可畅读，没有隐藏收费和会员门槛。',
  },
  {
    icon: 'ri-translate',
    title: '多语漫画覆盖',
    desc: '日漫官方汉化、国漫原版、韩漫精翻，三大语系动漫一站式收录，满足不同读者的喜好。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">平台特色优势</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么数百万读者选择51动漫网？五大优势为您揭晓
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-lg border border-background-200/60 p-5 md:p-6 hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}